import { EAvatarItemType } from '@NGUtils/enums';
import { useWornItems } from '@character/apis/queries/useWornItems/useWornItems';
import { IItem } from '@characterInventory/components/Avatar/Avatar.type';

const selector = (data: IItem[]) => data.filter((item) => item.isReference && item.type !== EAvatarItemType.body);

const useAvatarFaceAssets = () => {
	const { wornItems: avatarFaceAssets } = useWornItems(selector);
	return avatarFaceAssets;
};

export { useAvatarFaceAssets };
